module.exports = __webpack_public_path__ + "static/media/flowers_5.6653670c.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_5.csv
// module id = 762
// module chunks = 0